var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24303_142292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0009 64.0001C49.674 64.0001 64.0009 49.6732 64.0009 32.0001C64.0009 14.3269 49.674 0 32.0009 0C14.3277 0 0.000793457 14.3269 0.000793457 32.0001C0.000793457 49.6732 14.3277 64.0001 32.0009 64.0001Z",
    fill: "#3AB54A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0009 31.9999C64.0009 49.6 49.6009 64 32.0008 64C21.8008 64 12.8008 59.4 7.00076 52C12.4008 56.4 19.4008 59 27.0007 59C44.6008 59 59.0008 44.6 59.0008 27C59.0008 19.4 56.4008 12.4 52.0008 7C59.4009 12.7998 64.0009 21.7998 64.0009 31.9999Z",
    fill: "#299838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4009 22.8003L28.6009 45.6004C27.2008 47.2004 24.8009 47.2004 23.4008 45.6004L14.6008 35.8004C13.4009 34.4003 13.4009 32.2004 14.8008 30.8003C16.2008 29.6003 18.4008 29.6003 19.8008 31.0003L26.0009 38.0003L44.2008 18.2003C45.6009 16.8002 47.8008 16.6003 49.2009 18.0003C50.6008 19.2003 50.6008 21.6003 49.4009 22.8003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24303_142292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleGreen);
export default __webpack_public_path__ + "static/media/checkmark-circle-green.f5f61ee1409900f7bb2859a01ee02203.svg";
export { ForwardRef as ReactComponent };